import { EVENTS } from '../../bus/events.const';
import { WIRES } from '../wires';
import { Wiring } from '../wiring.interfaces';

export const LOCALE_WIRING: Wiring = {
  [EVENTS.LocaleChanged]: [
    WIRES.storeLocale
  ],
  [EVENTS.SearchLocaleChanged]: [
    WIRES.storeSearchLocale,
    WIRES.clearInputQuery,
    WIRES.clearSearch,
    WIRES.clearRelatedTags,
    WIRES.clearNextQueriesState
  ],
  [EVENTS.CurrencyChanged]: [
    WIRES.storeCurrency
  ]
};
